module.exports = __webpack_public_path__ + "static/media/media2.8b958a2d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banners/others/media2.png
// module id = 1229
// module chunks = 0